module.exports = __webpack_public_path__ + "products-33612c4d/image-with-message-illustration-1-5108a6c93be00bc3e6f823de853a29f6.png";